import {useContext, useEffect, useRef, useState} from 'react'
import _ from 'lodash'
import * as Y from 'yjs'
import {useInterval} from 'react-use'
import {IGetUserLabelsResponse, ILabel, ILabelTracks, LabelingContext} from '..'

// TODO: handle all sync logic in context?
// TODO: hook needs proper testing, seems defunct
export function useSyncedLabelTracks(catalog?: string, vionlabs_id?: string): ILabelTracks {
  const {isLabelingAllowed, getCrdtLabelTrackCollection, syncUpstreamLabels, haveLocalChanges} =
    useContext(LabelingContext)

  const crdtRef = useRef<Y.Map<Y.Map<ILabel<object> | undefined>>>()

  const [isBusy, setIsBusy] = useState(false)
  const [apiLabels, setApiLabels] = useState<IGetUserLabelsResponse>()
  const canLabel = isLabelingAllowed && _.isString(catalog) && catalog.length > 0

  useInterval(async () => {
    if (!catalog) return
    if (!vionlabs_id) return
    if (!haveLocalChanges(vionlabs_id)) return
    setIsBusy(true)
    await syncUpstreamLabels(catalog, vionlabs_id, true, true)
    setIsBusy(false)
  }, 30000)

  useEffect(() => {
    load()
    window.onbeforeunload = (e) => {
      if (!catalog) return
      if (!vionlabs_id) return
      if (!haveLocalChanges(vionlabs_id)) return
      async function f() {
        if (!catalog) return
        if (!vionlabs_id) return
        setIsBusy(true)
        await syncUpstreamLabels(catalog, vionlabs_id, true, true)
        setIsBusy(false)
      }
      f()
      e.returnValue = 'You have unsaved changes!'
      e.preventDefault()
    }
    return () => {
      window.onbeforeunload = null
      unload()
    }
  }, [vionlabs_id, canLabel])

  async function load() {
    if (!catalog) return
    if (!vionlabs_id) return
    setIsBusy(true)
    crdtRef.current = getCrdtLabelTrackCollection(vionlabs_id)
    setApiLabels(undefined)
    await syncUpstreamLabels(catalog, vionlabs_id, true, false)
    setIsBusy(false)
  }

  async function unload() {
    if (!catalog) return
    if (!vionlabs_id) return
    setIsBusy(true)
    await syncUpstreamLabels(catalog, vionlabs_id, false, true)
    crdtRef.current = undefined
    setApiLabels(undefined)
    setIsBusy(false)
  }

  return {
    isBusy,
    canLabel,
    crdtLabels: crdtRef.current,
    apiLabels,
  }
}
